module.exports = __webpack_public_path__ + "static/media/home_img1.8d2c47be.png";